import { useEffect } from "react";
import type { Runtime } from "./runtime";

// React owns this mount point only; the existing report/admin renderer owns its
// descendants until those screens are migrated component by component.
// `render` is a fresh closure on every pass, so the render effect keys off the
// route and the revision counter instead; the teardown runs on route change
// only, so a re-render triggered by the drawer itself cannot close it.
export default function LegacyMount({ runtime, render, path, revision }: {
  runtime: Runtime; render: () => void; path: string; revision: number;
}) {
  useEffect(() => {
    render();
    runtime.ui.repairDomText(document.getElementById("view"));
  }, [runtime, path, revision]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => () => {
    runtime.report.closeDrawer();
    document.querySelector(".source-popover")?.remove();
  }, [runtime, path]);

  return <div id="view" />;
}
